import { useState, useCallback } from 'react';
import { suggestEmailDomain } from '../utils/emailDomainSuggestions';

// Shared logic (not UI — AuthPage and StackSocialPage render this
// differently to match their own visual style) behind the "did you mean
// gmail.com?" suggestion. `everShown`/`accepted` are what get sent up to
// the server as submission metadata (see routes/auth.js and
// routes/stacksocial.js) so email_check_log can count how often this
// mechanism actually fires — sticky for the lifetime of one form fill, not
// just "is it visible right now", so a suggestion the user saw and then
// typed past (ignoring it) still counts as having fired.
export function useEmailTypoSuggestion(email) {
  const [everShown, setEverShown] = useState(false);
  const [accepted, setAccepted] = useState(false);
  // Remembers WHICH email value was dismissed — a dismissal only applies to
  // that exact typo, so editing the field again (a new typo, or a fix)
  // naturally brings the suggestion back instead of hiding it forever.
  const [dismissedFor, setDismissedFor] = useState(null);

  const suggestion = suggestEmailDomain(email);
  // "Adjusting state during render" (React-documented pattern, guarded so
  // it only ever fires the one extra re-render): cheaper and simpler here
  // than a useEffect for a single sticky boolean.
  if (suggestion && !everShown) setEverShown(true);

  const visible = !!suggestion && dismissedFor !== email;

  const dismiss = useCallback(() => setDismissedFor(email), [email]);
  const markAccepted = useCallback(() => setAccepted(true), []);

  return { suggestion, visible, dismiss, markAccepted, everShown, accepted };
}
